import { use, useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams, useNavigate } from 'react-router-dom';

export const Page403 = () => {
    const { token } = useSelector((state) => state.auth);
 const navigate = useNavigate();
    useEffect(() => {
        console.log("Token:", token);
    }, [token]);

    return (
        <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
            <h1 className="text-4xl font-bold text-red-600">403</h1>
            <p className="mt-4 text-lg text-gray-700">Access Denied</p>
            <p className="mt-2 text-sm text-gray-500">You do not have permission to view this page.</p>
              <button
          onClick={() => navigate('/')}
          className="bg-amber-600 text-white px-6 py-2 rounded-lg hover:bg-amber-700 transition-colors flex items-center gap-2"
          style={{ backgroundColor: '#fdf54d' }}
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
            
          </svg>
          Retour
        </button>
        </div>
    );
}